import { render, staticRenderFns } from "./comingSoon.vue?vue&type=template&id=1ee963c6"
import script from "./comingSoon.vue?vue&type=script&lang=js"
export * from "./comingSoon.vue?vue&type=script&lang=js"
import style0 from "./comingSoon.vue?vue&type=style&index=0&id=1ee963c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports